import { UNBOOK_REASONS, READABLE_REASONS } from './shared/constants'

export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_LONG_FORMAT = 'ddd D MMM'
export const DATE_NAME_FORMAT = 'DD MMM YYYY'
export const DATE_CHECKIN_FORMAT = 'DD MMM YYYY, hh:mm A'
export const HOUR_FORMAT = 'HH:mm'
export const DATETIME_PICKER_FORMAT = 'DD/MM/YYYY hh:mm a'
export const DATETIME_MISSION_FORMAT = 'MMM DD, YYYY h:mm A'
export const DAY_TIME_FORMAT = 'ddd Do h:mm a'

export const OBJECT_TYPE_CAMPAIGN = 'campaign'
export const OBJECT_TYPE_CITY_PLAN = 'city-plan'
export const OBJECT_TYPE_ROSTER = 'roster'
export const OBJECT_TYPE_MISSION = 'mission'
export const OBJECT_TYPE_AMBASSADOR = 'ambassador'
export const OBJECT_TYPE_USER = 'user'

export const ACTION_CREATE = 'create'
export const ACTION_EDIT = 'edit'
export const ACTION_VIEW = 'view'

export const UNBOOK_OPTIONS = [
  {
    label: READABLE_REASONS[UNBOOK_REASONS.CLIENT_REQUEST],
    value: UNBOOK_REASONS.CLIENT_REQUEST,
  },
  {
    label: READABLE_REASONS[UNBOOK_REASONS.BA_REQUEST],
    value: UNBOOK_REASONS.BA_REQUEST,
  },
  {
    label: READABLE_REASONS[UNBOOK_REASONS.BAD_WEATHER],
    value: UNBOOK_REASONS.BAD_WEATHER,
  },
  {
    label: READABLE_REASONS[UNBOOK_REASONS.CHEATING_SUSPICIOUS_BEHAVIOUR],
    value: UNBOOK_REASONS.CHEATING_SUSPICIOUS_BEHAVIOUR,
  },
]

export const NOTIFICATION_TYPES = {
  CHAT: 'CHAT',
}

export const PREDEFINED_COLORS = [
  { label: 'Dark Magenta', value: '#8B008B' },
  { label: 'Dark Olive Green', value: '#556B2F' },
  { label: 'Dark Salmon', value: '#E9967A' },
  { label: 'Medium Spring Green', value: '#00FA9A' },
  { label: 'Dark Orange', value: '#FF8C00' },
  { label: 'Light Pink', value: '#FFB6C1' },
  { label: 'Cyan', value: '#00FFFF' },
  { label: 'Orange Red', value: '#FF4500' },
  { label: 'Gold', value: '#FFD700' },
  { label: 'Dark Slate Gray', value: '#2F4F4F' },
  { label: 'Indian Red', value: '#CD5C5C' },
  { label: 'Purple', value: '#800080' },
  { label: 'Crimson', value: '#DC143C' },
  { label: 'Sienna', value: '#A0522D' },
  { label: 'Olive', value: '#808000' },
  { label: 'Medium Purple', value: '#9370DB' },
  { label: 'Deep Sky Blue', value: '#00BFFF' },
  { label: 'Medium Sea Green', value: '#3CB371' },
  { label: 'Dark Cyan', value: '#008B8B' },
]



// WEBPACK FOOTER //
// ./src/constants.js